import { withModal } from "@/account/AccountModal";
import { createGlobalStyle } from "styled-components";
import capitalize from "lodash/capitalize";
import Button from "@/atoms/Button";

const GlobalStyle = createGlobalStyle`
  .modal {
    background: #fff !important;
    width: 480px;
  }
`;

const ConfirmDisconnectAccountModal = ({ provider, onConfirm, onClose }) => {
  return (
    <div>
      <div className={"modal-title mb-8"}>
        Are you sure you want to disconnect your {capitalize(provider)} account?
      </div>
      <Button onClick={onConfirm} className={"block w-full"} color={"teal"}>
        Yes
      </Button>
      <Button level={"secondary"} onClick={onClose} className={"mt-4 w-full"}>
        Cancel
      </Button>
      <GlobalStyle />
    </div>
  );
};

export default withModal(ConfirmDisconnectAccountModal);
